
import {IMenuSticky} from "../interfaces";
import {getHashByPrefix} from "../../../../domain/common";

/**
 * check in hash
 */
export const getHashExcludePrefix = (toFind:string) => {

    const _hash =  window.location.hash.substring(1);
    const _curPrefix = getHashByPrefix(toFind);
    //console.log('getHashExcludePrefix: ',_hash.replace(_curPrefix + "|",""));
    return _hash.replace(_curPrefix + "|","");

};

export const getMenuSticky = () : IMenuSticky[] => {
    const menuDataObj = document.getElementById('menu-sticky-json-app');
    if(!menuDataObj || !menuDataObj.textContent)
        return [];

    let menuList: IMenuSticky[] =[];

    menuDataObj.textContent.split(', ').forEach( (str, i, arr) => {
        //console.log(arr[i]);
        const menu: IMenuSticky = {
            name: arr[i],
            id: arr[i].replace(/\s+/g, '-').toLowerCase()
        };
        menuList.push(menu);
    });

    return menuList;
};
export const getMenuSelected = (hash: string, menuList:IMenuSticky[]) : IMenuSticky=> {
    let menuSelected = menuList[0];
    if(!hash || hash === '')
        return  menuSelected;

    menuList.forEach((item) => {
       if(hash === 'tab-' + item.id)
           menuSelected = item;
    });


    return menuSelected;
};

